import { AxiosResponse } from 'axios';
import request from '../request';
import type { IAuth, ILoginData, ILoginResponseData } from './type';
import type { IService } from '../../infrastructure';
import type { IUserData } from './type';

export const loginService = async (
  loginRequestData: IAuth,
): Promise<ILoginData> => {
  const data: IService<IAuth> = {
    data: loginRequestData,
    method: 'POST',
    relativePath: 'trust/login',
  };
  const response = await request.requestService<
    AxiosResponse<ILoginResponseData>,
    IAuth
  >(data, false);
  return response.data;
};

export const registerService = async (
  registerRequestData: IAuth,
): Promise<IUserData> => {
  const data: IService<IAuth> = {
    data: registerRequestData,
    method: 'POST',
    relativePath: 'trust/register',
  };
  const response = await request.requestService<
    AxiosResponse<IUserData>,
    IAuth
  >(data, false);
  return response.data;
};

export const googleAuthService = async (): Promise<any> => {
  const header = { 'Content-Type': 'application/json; charset=utf-8' };
  const data: IService = {
    method: 'POST',
    relativePath: '/trust/google/start2',
    headers: header,
  };

  const response = await request.requestService<AxiosResponse<any>>(data);

  return response.data;
};

export const googleAuthSession = async (): Promise<any> => {
  const header = { 'Content-Type': 'application/json; charset=utf-8' };
  const data: IService = {
    method: 'POST',
    relativePath: '/trust/get-session',
    headers: header,
  };

  const response = await request.requestService<AxiosResponse<any>>(data);

  return response.data;
};
